import React from "react";
import OrdersTable from "./OrdersTable";

const CompletedOrders = () => {
  return <OrdersTable type="Completed" title="Completed Orders" />;
};

export default CompletedOrders;
